import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";
import { ReduxStateType } from "redux-store/types";

export interface ICVResponse {
  applyInfoId: string;
  fullName: string;
  prevRoundNumber: string;
  nextRoundNumber: string;
  participateStatusName: string;
  beginDate: string;
  endDate: string;
  hrFinalInterview: string;
  hrReviewStatusName: string;
  hrNotMtrReason: string;
  submitStatusName: string;
  participateStatus: string;
  panelResponses: any[];
  refuseReason: string;
  finalStatus: string;
  finalStatusName: string;
  panelParticipateStatus: string;
  panelParticipateStatusName: string;
  result: string;
  resultName: string;
  endTime: string;
  startTime: string;
}

interface InitialState {
  status: ReduxStateType;
  form: {
    addressName: string;
    scheduleId: string;
    scheduleName: string;
    date: string;
    endDate: string;
    programCode: string;
    programName: string;
    departmentOfManager?: string;
    method: string;
    address: string;
    manageCode: string;
    panel: string;
    note: string;
    updatedAt: string;
    updatedBy: string;
    canceledAt: string;
    canceledBy: string;
    cancelReason: string;
    scheduleStatus: string;
    hrFinalInterview: string;
    methodName: string;
    listCvResponse: ICVResponse[];
    departmentLevel1Name?: string;
    departmentLevel2Name?: string;
    departmentLevel3Name?: string;
    managerName?: string;
    panelResponse: {
      employeeCode: string;
      participateStatus: string;
      refuseReason: string;
      name: string;
    }[];
  };
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  form: {
    addressName: "",
    scheduleId: "",
    scheduleName: "",
    date: "",
    endDate: "",
    programCode: "",
    method: "",
    address: "",
    manageCode: "",
    panel: "",
    note: "",
    updatedAt: "",
    updatedBy: "",
    canceledAt: "",
    canceledBy: "",
    cancelReason: "",
    scheduleStatus: "",
    programName: "",
    methodName: "",
    listCvResponse: [],
    panelResponse: [],
    hrFinalInterview: "",
  },
};

const formDetailInterviewSlice = createSlice({
  name: "formCreateInterview",
  initialState,
  reducers: {
    updateFormDetailInterview: (state, action) => {
      Object.assign(state.form, action.payload);
    },
    updateFormDetailCV: (state, action) => {
      const keys = Object.keys(action.payload);
      for (let i = 0; i < keys.length; i++) {
        set(state.form, keys[i], action.payload[keys[i]]);
      }
    },
    resetFormDetailInterview: () => ({ ...initialState }),
  },
});

export const {
  updateFormDetailInterview,
  resetFormDetailInterview,
  updateFormDetailCV,
} = formDetailInterviewSlice.actions;

export default formDetailInterviewSlice.reducer;
